// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-loading-overlay {
  display: none;
  /* Hide by default */
}

.custom-loading-overlay.active {
  display: flex !important;
  /* Show when active */
  position: fixed !important;
  top: 0 !important;
  left: 200px !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 1000 !important;
}`, "",{"version":3,"sources":["webpack://./../account/src/pages/CreateAccount/Overlay.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAAe,oBAAA;AAEjB;;AACA;EACE,wBAAA;EAA0B,qBAAA;EAC1B,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yCAAA;EACA,wBAAA;AAGF","sourcesContent":[".custom-loading-overlay {\n  display: none; /* Hide by default */\n}\n\n.custom-loading-overlay.active {\n  display: flex !important; /* Show when active */\n  position: fixed !important;\n  top: 0 !important;\n  left: 200px !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  background: rgba(0, 0, 0, 0.5) !important;\n  z-index: 1000 !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
